import { getActivityApi, joinActivityApi } from '../api';
import type { RecallAuth } from '../utils/loginAuth';
import { callErrorTrack } from '../utils/track';

export const getActivity = () => {
    return new Promise<{ activityId?: string | number }>((resolve, reject) => {
        getActivityApi().then(res => {
            const { errno, errmsg, traceId } = res;

            if (errno === 0) {
                resolve((res?.data ?? {}) as { activityId?: string | number });
            } else {
                callErrorTrack('getActivityApi', `${errmsg}_${traceId}`);
                reject(res);
            }
        }).catch(err => {
            callErrorTrack('getActivityApi', err.message);
            reject(err || 'getActivityApi fail');
        });
    });
};

export const receiveReward = (authOverride?: Partial<RecallAuth> | null) => {
    return new Promise((resolve, reject) => {
        joinActivityApi(authOverride).then(res => {
            const { errno, errmsg, traceId } = res;

            if (errno === 0) {
                resolve(res?.data);
            } else {
                callErrorTrack('joinActivityApi', `${errmsg}_${traceId}`);
                reject(res);
            }
        }).catch(err => {
            callErrorTrack('joinActivityApi', err.message);
            reject(err || 'joinActivityApi fail');
        });
    });
};
